import PropTypes from 'prop-types'
import { Children, Component } from 'react'

import Card from '@/components/Card'

class SpaceLandingBody extends Component<any, any> {
  static displayName = 'SpaceLandingBody'

  static propTypes = {
    children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.object)])
  }

  static defaultProps = {
    children: null
  }

  state = {
    leftSide: [],
    rightSide: []
  }

  componentDidMount() {
    const leftSide: any = []
    const rightSide: any = []

    Children.forEach(this.props.children, child => {
      child.type === Card ? leftSide.push(child) : rightSide.push(child)
    })

    this.setState({ leftSide, rightSide })
  }

  render = () => (
    <div className="space-page-landing-send">
      <div className="left-column">{this.state.leftSide}</div>
      <div className="right-column">{this.state.rightSide}</div>
    </div>
  )
}

export default SpaceLandingBody
